import { useAnimalValidateStore } from '../../Stores/useAnimalValidateStore'
import { Minus, Plus } from '../Icons'

type CoverageExpandProps = {
  isOptional: boolean
  animalId: string
}

export const getCurrentAnimalExpandedKey = (
  isOptional: boolean,
  animalId: string,
) => `expand-${animalId}-${isOptional ? 'optional' : 'base'}`

export const CoverageExpand = ({
  isOptional,
  animalId,
}: CoverageExpandProps) => {
  const { expandCoverageAnimal, setExpandCoverageAnimal } =
    useAnimalValidateStore()

  return (
    <div
      className="coverage-expand"
      onClick={() => {
        setExpandCoverageAnimal({
          [getCurrentAnimalExpandedKey(isOptional, animalId)]:
            !expandCoverageAnimal?.[
              getCurrentAnimalExpandedKey(isOptional, animalId)
            ],
        })
      }}
    >
      {expandCoverageAnimal?.[
        getCurrentAnimalExpandedKey(isOptional, animalId)
      ] ? (
        <Plus />
      ) : (
        <Minus />
      )}
    </div>
  )
}
